import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const AbuSimbel = {
  id: '45',
  name: 'Abu Simbel',
  era: EraType.minoanEra,
  icon: 'simbel',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.EGYPT,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.TOTAL_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        5,
        6.4,
        7.5,
        8.4,
        9.1,  // 5
        9.8,
        10.4,
        10.9,
        11.4,
        11.9, // 10
        12.3,
        12.8,
        13.2,
        13.5,
        13.9, // 15
        14.3,
        14.6,
        14.9,
        15.3,
        15.6, // 20
        15.9,
        16.2,
        16.5,
        16.7,
        17,   // 25
        17.3,
        17.5,
        17.8,
        18,
        18.3  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asPerLevel([
          1,
          1,
          1,
          1,
          1, // 5
          1,
          1,
          1,
          1,
          2, // 10
          2,
          2,
          2,
          2,
          2, // 15
          2,
          2,
          2,
          2,
          3, // 20
          3,
          3,
          3,
          3,
          3, // 25
          3,
          3,
          3,
          3,
          4  // 30
        ])
        .withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(1).withKind(WonderKind.STATUE),
      effect: null,
    }
  ],
};

export default AbuSimbel;
